import { ColocaIsotype } from "@/shared/components/data-display/ColocaIsotype";

/** The card as a small object: Coloca's colour, a chip, the mark. Decorative; the caption names it. */
export function MiniCard() {
  return (
    <span className="relative block h-6 w-9 rounded-[5px] bg-primary shadow-sm">
      <span className="absolute top-1.5 left-1 h-1.5 w-2 rounded-[1.5px] bg-primary-foreground/45" />
      <ColocaIsotype className="absolute top-1 right-1 size-2.5 text-primary-foreground" />
      <span className="absolute right-1 bottom-1 left-1 h-0.5 rounded-full bg-primary-foreground/35" />
    </span>
  );
}
